export default __webpack_public_path__ + "static/media/Mulish-ExtraLight.dbefefed.ttf";